import { render, staticRenderFns } from "./SingleResponse.vue?vue&type=template&id=245e9e40&scoped=true&"
import script from "./SingleResponse.vue?vue&type=script&lang=js&"
export * from "./SingleResponse.vue?vue&type=script&lang=js&"
import style0 from "./SingleResponse.vue?vue&type=style&index=0&id=245e9e40&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245e9e40",
  null
  
)

export default component.exports